export default "__VITE_ASSET__BoOuUGBx__"